import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useSelector } from 'react-redux';
import {
  HomePage,
  FAQPage,
  OrderSuccessPage,
  ProductDetailsPage,
  ProfilePage,
  OrderDetailsPage,
  TrackOrderPage,
  UserInbox,
} from "./routes/Routes.js";

import {
  AdminDashboardPage,
  AdminDashboardUsers,
  AdminDashboardSellers,
  AdminDashboardOrders,
  AdminDashboardProducts,
  AdminDashboardEvents,
  AdminDashboardWithdraw
} from "./routes/AdminRoutes";
import { DeliveryLogin, AllOrdersForDelivery, OrderDetails } from "./routes/DeliveryRoutes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Store from "./redux/store";
import { loadDeliveryUser } from "./redux/actions/deliveryUser";
import { getAllOrdersOfShop } from "./redux/actions/order";
import { getAllOrderStatusOfDelivery } from "./redux/actions/orderStatus.js" 
import ProtectedRoute from "./routes/ProtectedRoute";
import ProtectedAdminRoute from "./routes/ProtectedAdminRoute";

import axios from "axios";
import { server } from "./server";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import About from "../src/Company/About";
import Contact from "./Company/ContactUs.js";
import PrivacyPolicy from "./Company/PrivecyPolicy.js";
import Footer from "./Company/Footer.js";
import Header from "./Company/Header.js";
import ShopPricing from './Company/Pricing.js';

const App = () => {
  const [stripeApikey, setStripeApiKey] = useState("");
  const { deliveryUser, isLoading } = useSelector((state) => state.deliveryUser);

  async function getStripeApikey() {
    const { data } = await axios.get(`${server}/payment/stripeapikey`);
    setStripeApiKey(data.stripeApikey);
  }

  useEffect(() => {
    // Store.dispatch(loadUser());
    // Store.dispatch(loadSeller());
    Store.dispatch(loadDeliveryUser());
    // Store.dispatch(getAllProducts());
    // Store.dispatch(getAllEvents());
    // getStripeApikey();
    Store.dispatch(getAllOrdersOfShop(deliveryUser?.deliveryUser?.assignedSellerId));
    Store.dispatch(getAllOrderStatusOfDelivery())
  }, []);

  // useEffect(() => {
  //   dispatch(getAllProductsShop(seller._id));
  // }, [dispatch]);

  return (
    <BrowserRouter>
      {/* {stripeApikey && (
        <Elements stripe={loadStripe(stripeApikey)}>
          <Routes>
            <Route
              path="/payment"
              element={
                <ProtectedRoute>
                  <PaymentPage />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Elements>
      )} */}
      <Routes>
        <Route path="/" element={<ProtectedRoute> <HomePage /> </ProtectedRoute>} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/profile" element={ <ProtectedRoute> <ProfilePage /> </ProtectedRoute> } />

        {/* Delivery */}
        <Route path="/delivery-login" element={ <DeliveryLogin /> } />
        <Route path="/all-orders" element={ <AllOrdersForDelivery /> } />
        <Route path="/order/:orderId" element={ <OrderDetails /> } />
        {/* <Route path="/deliveryHistory" element={ DeliveryHistory } /> */}
        
        {/* Admin Routes */}
        {/* <Route path="/admin/dashboard" element={ <ProtectedAdminRoute> <AdminDashboardPage /> </ProtectedAdminRoute> } />
        <Route path="/admin-users" element={ <ProtectedAdminRoute> <AdminDashboardUsers /> </ProtectedAdminRoute> } />
        <Route path="/admin-sellers" element={ <ProtectedAdminRoute> <AdminDashboardSellers /> </ProtectedAdminRoute> } />
        <Route path="/admin-orders" element={ <ProtectedAdminRoute> <AdminDashboardOrders /> </ProtectedAdminRoute> } />
        <Route path="/admin-products" element={ <ProtectedAdminRoute> <AdminDashboardProducts /> </ProtectedAdminRoute> } />
        <Route path="/admin-events" element={ <ProtectedAdminRoute> <AdminDashboardEvents /> </ProtectedAdminRoute> } />
        <Route path="/admin-withdraw-request" element={ <ProtectedAdminRoute> <AdminDashboardWithdraw /> </ProtectedAdminRoute> } /> */}

        {/* Static Pages */}
        <Route path="/pricing" element={ <ShopPricing />} />
        <Route path="/about" element={ <About />} />
        <Route path="/contact-us" element={ <Contact />} />
        <Route path="/privacy-policy" element={ <PrivacyPolicy />} />
        <Route path="/footer" element={ <Footer />} />
        <Route path="/header" element={ <Header />} />
      </Routes>
      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </BrowserRouter>
  );
};

export default App;
